import type { RouteRecordRaw, Router } from 'vue-router'

const BuyContractRoutes: RouteRecordRaw = {
  path: '/contract/estate/muzarah',
  name: 'MuzarahEstateModulePages',
  children: [
    {
      path: '',
      name: 'MuzarahEstateMainRoute',
      component: () => import('./views/MuzarahView.vue'),
      meta: {
        title: 'muzarahEstate.muzarahContract',
      },
    },
    {
      path: 'create',
      name: 'MuzarahEstateCreateRoute',
      component: () => import('./views/MuzarahUpsertView.vue'),
      meta: {
        title: 'muzarahEstate.createViewTitle',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:muzarahEstateId',
      name: 'MuzarahEstateEditRoute',
      component: () => import('./views/MuzarahUpsertView.vue'),
      meta: {
        title: 'muzarahEstate.editViewTitle',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:muzarahEstateId',
      name: 'ViewMuzarahEstateRoute',
      component: () => import('./views/SingleMuzarahView.vue'),
      meta: {
        title: 'muzarahEstate.singleViewTitle',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(BuyContractRoutes)
}
